export const ERROR_MESSAGES: { [key: number]: string } = {
    400: 'Requisição inválida. Por favor, verifique os dados enviados.',
    401: 'Você não está autorizado a ver isso.',
    403: 'Acesso negado. Você não tem permissão para acessar este recurso.',
    404: 'Recurso não encontrado.',
    408: 'Tempo de requisição esgotado. Tente novamente mais tarde.',
    500: 'Erro interno do servidor. Por favor, tente novamente mais tarde.',
    502: 'Erro de gateway. O serviço está temporariamente indisponível.',
    503: 'Serviço indisponível no momento. Tente novamente em alguns minutos.',
    504: 'Tempo de resposta do gateway esgotado. Verifique sua conexão de rede.',
    429: 'Muitas solicitações.'
};
